// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"30":"newsAndEvents","242":"solution","415":"details","562":"brand","594":"about","806":"development"}[chunkId] + "." + {"30":"1c0fb0aa","242":"4602b4ac","415":"326455aa","562":"8d0243bf","594":"c55e8980","806":"e0e0c905"}[chunkId] + ".js";
};